import React ,  {useEffect, useState}from 'react'
import { Button, Form ,TextArea,} from 'semantic-ui-react';
import { Field, useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import {ADD_PUBLIC , PUBLIC_COMPLET } from '../../../../gql/publication';
//import Preview from '../../Publications/PreviewPublication./Preview';
import "./Mosetting.scss";
//import usePublic from '../../../hooks/usePublic';



export default function Promo (props) {
const  { publication , setShowModal } = props;
const [completPublic] = useMutation (PUBLIC_COMPLET);
const desk = publication.description


console.log(publication)

console.log (publication._id)



const formik = useFormik ({
  initialValues:initialValue(),


  validationSchema:Yup.object({
    
    description:Yup.string().required(),
    
   }),


  onSubmit: async (formv) => {try
    { const formData= formv;
      console.log(formv);

       await completPublic({
        variables:{
          input:{
            idPublication:publication._id,
            
            description:formData.description,
          },
          },}
      );
      toast.success (" Descripcion Actualizada ");

      setTimeout(() =>  setShowModal (false),3000);


      
}    catch (error) {
      toast.error(error.message);
      console.log (error)
      console.log (formv)
    }
  },

 });





  return (
    
        <Form  onSubmit = {formik.handleSubmit} className= "mosset">
        <h2>
          Cambia la descripcion, agreaga  detalles de tu Articulo❗  
        </h2>
          
   <TextArea  type= "text" placeholder = {publication.description}
         name= "description"  
         value = {formik.values.description}
        onChange = {formik.handleChange}
        error={formik.errors.description && true}

      />

      <Button type= "submit" className=' btn-submit'>  * Publicar * </Button> 

        </Form>
    
  )
}
function initialValue() {
  return  {
    "idPublication": "",
    "description":"",  
  };
};
